import { render } from "./BankPayments.vue?vue&type=template&id=5b672574&scoped=true"
import script from "./BankPayments.vue?vue&type=script&lang=js"
export * from "./BankPayments.vue?vue&type=script&lang=js"

import "./BankPayments.vue?vue&type=style&index=0&id=5b672574&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b672574"]])

export default __exports__